import { SET_PLAN } from "../allAction/planActions";

const initialState = { plan: null };

export const planReducer = (state = initialState, action) => {
  console.log("did it eve4n run!")
  switch (action.type) {
    case SET_PLAN:
      return { ...state, plan: action.payload };
    default:
      return state;
  }
};
